import { FC } from "react";
import classNames from "classnames";

import { IValueWithDifferenceProps } from "./types";
import { mapDifferenceStyle } from "./utils/mapDifference";
import Skeleton from "../Skeleton/Skeleton";

import styles from "./ValueWithDifference.module.css";



const ValueWithDifference: FC<IValueWithDifferenceProps> = ({ value, difference, className, icon, isWhiteStyle }) => {
  if (value === undefined || difference === undefined) {
    return <Skeleton height={40} width={160} />
  };

  const differenceStyle = mapDifferenceStyle(Number(difference as string));
  
  return (
    <div className={classNames(styles["score"], className)}>
      {icon && <span className={styles["score__icon"]}>{icon}</span>}
      <p>{value}</p>
      <span className={classNames(styles["score__difference"], isWhiteStyle ? styles["style__white"] : styles[differenceStyle.style])}>
        {differenceStyle.value}
      </span>
    </div>
  );
};

export default ValueWithDifference;
